import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPackagistComponent } from './simple-icons-packagist.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPackagistComponent ],
    exports:      [ SimpleIconsPackagistComponent ],
    bootstrap:    []
})
export class SimpleIconsPackagistModule {}
